import { render, staticRenderFns } from "./InterestContent.vue?vue&type=template&id=9612efe2&"
import script from "./InterestContent.vue?vue&type=script&lang=js&"
export * from "./InterestContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports